import styled from 'styled-components';

import { getMinScreenWidths } from 'Utils/screenSizes.utils';

export const FooterFlexContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;

  justify-content: space-between;
  gap: 16px;

  ${getMinScreenWidths.tablet} {
    flex-direction: row;

    & > div:last-child {
      align-items: flex-end;
    }
  }
`;

export const FooterLink = styled.a`
  color: var(--footer-link-color);
  line-height: 24px;
`;
